import * as _ from 'underscore'

import { Enums } from "../common/enums"

import { ConvertHelper } from '../../helpers'
import { ICopyable, IOpChangeState } from "../util/interfaces"

export class OpPacketDataArch implements IOpChangeState, ICopyable<OpPacketDataArch> {

    //#region Properties

    public serialNbr: string
    public idAction: number
    public idPacket: number
    public idDataType: number
    public name: string
    public indexNBR: number
    public value: any
    public unit: string
    public time: Date
    public status: string

    //#endregion


    //#region Custom properties

    public opState: Enums.OpChangeState

    public idData: number
    public get index(): number { return this.indexNBR != null ? this.indexNBR : 0 }
    public set index(value: number) { this.indexNBR = value }

    public referencedObject: any
    public previousValue: any

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    public toString(): string {
        return this.name
    }

    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.serialNbr = opObj.SERIAL_NBR
            this.idAction = opObj.ID_ACTION
            this.idPacket = opObj.ID_PACKET
            this.idDataType = opObj.ID_DATA_TYPE
            this.name = opObj.NAME
            this.indexNBR = opObj.INDEX_NBR
            this.value = opObj.VALUE
            this.unit = opObj.UNIT

            if (opObj.TIME != null) {
                this.time = ConvertHelper.stringToDate(opObj.TIME)
            }

            this.status = opObj.STATUS

            this.opState = opObj.OpState

            this.idData = opObj.IdData
            this.referencedObject = opObj.ReferencedObject
            this.previousValue = opObj.PreviousValue
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {

            SERIAL_NBR: this.serialNbr,
            ID_ACTION: this.idAction,
            ID_PACKET: this.idPacket,
            ID_DATA_TYPE: this.idDataType,
            NAME: this.name,
            INDEX_NBR: this.indexNBR,
            VALUE: this.value,
            UNIT: this.unit,
            TIME: this.time != null ? ConvertHelper.dateToString(this.time, { netFormat: true, includeTimeZone: true }) : undefined,
            STATUS: this.status,
            OpState: this.opState,
            IdData: this.idData,
            ReferencedObject: this.referencedObject,
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpPacketDataArch {
        const newPacket: OpPacketDataArch = new OpPacketDataArch(null)

        newPacket.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newPacket
    }

    public copy(source: OpPacketDataArch, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {

        }

        if (includeCustomProperties) {
            this.idData = source.idData
            this.referencedObject = source.referencedObject
            this.previousValue = source.previousValue
        }

        if (includeDataList) {
            //no dataList
        }

        if (includeDynamicValues) {
            //no dynamic values
        }

        this.serialNbr = source.serialNbr
        this.idAction = source.idAction
        this.idPacket = source.idPacket
        this.idDataType = source.idDataType
        this.name = source.name
        this.indexNBR = source.indexNBR
        this.value = source.value
        this.unit = source.unit
        this.time = source.time
        this.status = source.status

        this.opState = source.opState
    }

    //#endregion
}